export default "__VITE_ASSET__BFuQRWms__"